'use client';

import { createTRPCReact } from '@trpc/react-query';
import { createSafeTrpcUtils } from '@/lib/trpc/utils-safe-proxy';
import type { AppRouter } from '@/types/app-router';

const trpcInstance: ReturnType<typeof createTRPCReact<AppRouter>> = createTRPCReact<AppRouter>();

// Guard the `useUtils()` proxy at runtime so dev overlays can’t trip the
// `contextMap[utilName]` error when they enumerate arbitrary helpers.
if (typeof trpcInstance.useUtils === 'function') {
  const originalUseUtils = trpcInstance.useUtils.bind(trpcInstance);
  trpcInstance.useUtils = ((...arguments_) => {
    const utils = originalUseUtils(...arguments_);
    return createSafeTrpcUtils(utils);
  }) as typeof trpcInstance.useUtils;
}

export default trpcInstance;
